<template>
  <div>
    <v-layout wrap justify-start>
      <v-flex pt-4 md5 text-left>
        <v-layout wrap justify-start>
          <v-flex xs12 md6>
            <span style="font-family:opensansextrabold;font-size:20px;color:#4A3E3E;">Ratings</span>
          </v-flex>
          <v-flex xs1></v-flex>
          <v-flex xs11 text-left>
            <v-layout wrap justify-center>
              <v-flex xs3 sm3 md2 text-left>
                <span style="font-family:opensanslight;font-size:50px;color:#4A3E3E;">3.0</span>
              </v-flex>
              <v-flex xs9 sm9 md10 text-left class="align-self-center">
                <span v-for="(item,i) in 3" :key="i">
                  <v-icon color="#FFC107" size="16px">mdi-star</v-icon>
                </span>
                <span v-for="(item,i) in 2" :key="i">
                  <v-icon size="16px">mdi-star-outline mdi-dark mdi-inactive</v-icon>
                </span>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-start>
              <v-flex xs3 sm3 md2>
                <span style="font-family:opensansregular;font-size:14px;color:#878787;">1209 rated</span>
              </v-flex>
              <v-flex xs9 sm9 md10>
                <span style="font-family:opensansregular;font-size:14px;color:#878787;">847 reviews</span>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-start>
              <v-flex xs3 sm3 md2>
                <span style="font-family:opensanslight;font-size:30px;color:#000000;">+ 1.1</span>
              </v-flex>
              <v-flex xs9 sm9 md10 class="align-self-center">
                <span
                  style="font-family:opensansregular;font-size:12px;color:#000000;"
                >Increased regarding your rating</span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs1></v-flex>
          <v-flex xs11 md8>
            <v-layout wrap justify-start v-for="(item,i) in ratings" :key="i">
              <v-flex class="align-self-center">
                <v-layout wrap justify-center>
                  <v-flex xs2>
                    <v-icon color="#D1D1D1" size="12px">mdi-star</v-icon>
                    <span
                      style="font-family:opensanssemibold;font-size:14px;color:#000000;"
                    >&nbsp;{{item.name}}</span>
                  </v-flex>
                  <v-flex xs8 class="align-self-center">
                    <v-progress-linear
                      rounded
                      background-opacity="0"
                      :buffer-value="50"
                      :color="item.color"
                      :value="item.value"
                    ></v-progress-linear>
                  </v-flex>
                  <v-flex xs2>
                    <span
                      style="font-family:opensanssemibold;font-size:14px;color:#000000;"
                    >&nbsp;{{item.total}}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex pt-4 md7 text-left>
        <v-layout wrap justify-start>
          <v-flex xs12 md6>
            <span style="font-family:opensansextrabold;font-size:20px;color:#4A3E3E;">Review</span>
          </v-flex>
        </v-layout>
        <v-layout v-for="(item,i) in 2" :key="i" wrap justify-start>
          <v-flex xs4>
            <v-layout wrap justify-center class="text-self-center">
              <v-flex xs1>
                <v-img src="./../../assets/account.svg" height="50px" contain></v-img>
              </v-flex>
              <v-flex xs11 text-left>
                <v-layout wrap justify-start>
                  <v-flex xs12>
                    <span
                      style="font-family:opensansregular;font-size:14px;color:#000000;"
                    >Stevan Wilson</span>
                  </v-flex>
                  <v-flex xs12>
                    <span v-for="(item,i) in 3" :key="i">
                      <v-icon color="#FFC107" size="16px">mdi-star</v-icon>
                    </span>
                    <span v-for="(item,i) in 2" :key="i">
                      <v-icon size="16px">mdi-star-outline mdi-dark mdi-inactive</v-icon>
                    </span>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs8 md6 text-right>
            <span
              style="font-family:opensansregular;font-size:14px;color:#757575;"
            >Reviewed on May 13th, 04:34pm</span>
          </v-flex>
          <v-flex xs12 md10 text-justify>
            <span style="font-family:opensansregular;font-size:12px;color:#000000;">
              Mostly I Take It with Honey sometimes , You can add A Little Amount Of sugar too if
              you want Boil milk with - Cardmom + Ginger + cloves Add Some Honey With boil Milk & Corn Flakes
              In A bowl *if You Want To Unload The whole Packet in A jar , Then I had Used A 10 kg , You can see All 1 kg Fits in It
            </span>
          </v-flex>
          <v-flex xs12 md10 py-2>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  data() {
    return {
      productRating: 3,
      ratings: [
        { name: "5", color: "#31B531", value: 90, total: 980 },
        { name: "4", color: "#2D86C3", value: 40, total: 87 },
        { name: "3", color: "#EFCF00", value: 20, total: 45 },
        { name: "2", color: "#DC221C", value: 10, total: 10 },
        { name: "1", color: "#DC221C", value: 2, total: 2 },
      ],
    };
  },
  methods: {},
};
</script>